import { PagedSearch } from '../../../shared/model/index';

export class FormSearch extends PagedSearch {
  public FormId: number;
  public ShowInactive: boolean;
}
